export default getText => key =>
  ({
    appointments: getText('Appointments', 'Home_Tabs_Header'),
    encounters: getText('Active Encounters', 'Home_Tabs_Header'),
  }[key])
